import React, { useEffect, useState } from "react"
import ContentLayoutHeader from "../../../../components/layouts/ContentLayoutHeader.layout"
import BeachAccessOutlinedIcon from "@mui/icons-material/BeachAccessOutlined"
import { BREAKPOINTS } from "../../../../consts/responsiveBreakpoints.consts"
import { useSession } from "../../../../hooks/auth/useSession.hook"
import useScreenDimensionsContext from "../../../../hooks/contextConsumers/useScreenDimensionsContext.hook"
import { capitalizeFirstLetter } from "../../../../utils/strings.utils"
import PeriodNavigator from "../../../../components/compounds/bigCalendar/PeriodNavigator.compound"
import {
  MY_VACATION_STATES,
  VACATION_PERIOD_NAVIGATOR_MODES,
} from "../../../../consts/modules/vacations.consts"
import { DateTime } from "luxon"
import { getOldestYearWithVacations } from "../../../../services/vacation.service"
import Tooltip from "../../../../components/atoms/Tooltip.atom"
import Button from "../../../../components/atoms/Button.atom"
import { ButtonWithCounter } from "../../../../components/compounds/ButtonWithCounter.compund"
import { CalendarAddIcon } from "../../../../design/assests/images/icons/CalendarAddIcon"

const VacationsHeader = ({
  selectedPeriod,
  setSelectedPeriod,
  loading,
  mode,
  setCreateModalVisible,
  disabled,
  showHolidaysModal,
  holidaysAmount = 0,
}) => {
  const { screenWidth } = useScreenDimensionsContext()
  const { user } = useSession()
  const [minYear, setMinYear] = useState(DateTime.local().year)
  useEffect(() => {
    fetchMinDate()
  }, [])

  const fetchMinDate = async () => {
    try {
      const response = await getOldestYearWithVacations()
      if (!response.success) {
        throw new Error(response.message)
      }
      const minDate = response.result
      setMinYear(minDate)
    } catch (error) {
      console.error("Error fetching min date:", error)
    }
  }
  const buttonHeaderProps = {
    label: "Crear solicitud",
    icon: <BeachAccessOutlinedIcon className="mr-2" />,
    className: "h-fit vacations-new-button",
    onClick: (e) => setCreateModalVisible(MY_VACATION_STATES.CREATE),
    disabled: disabled,
  }

  const isMobile = screenWidth <= BREAKPOINTS.MOBILE_BREAKPOINT

  const subtitleTemplate = () => {
    return (
      <div className="flex gap-3 align-items-center mt-2 mb-0">
        <PeriodNavigator
          selectedPeriod={selectedPeriod}
          setSelectedPeriod={setSelectedPeriod}
          loading={loading}
          minDate={DateTime.local().set({ year: minYear })}
          maxDate={DateTime.now().plus({ year: 1 }).endOf("year")}
        />
        <div className="flex gap-2 align-items-center text-xl font-semibold">
          <i className="pi pi-calendar text-2xl"></i>
          <span className="line-height-1">
            {mode === VACATION_PERIOD_NAVIGATOR_MODES.MANAGEMENT ?
              selectedPeriod[0].year
            : <>
                <span className="teammember-navigation-period">
                  {`${capitalizeFirstLetter(selectedPeriod?.[0].toFormat("yyyy"))} - ${capitalizeFirstLetter(selectedPeriod?.[1].toFormat("yyyy"))}`}
                </span>
                <Tooltip
                  target=".teammember-navigation-period"
                  position="bottom"
                >
                  {`${capitalizeFirstLetter(selectedPeriod?.[0].toFormat("dd/MM/yyyy"))} - ${capitalizeFirstLetter(selectedPeriod?.[1].toFormat("dd/MM/yyyy"))}`}
                </Tooltip>
              </>
            }
          </span>
        </div>
      </div>
    )
  }
  return (
    <>
      <ContentLayoutHeader
        title={
          mode === VACATION_PERIOD_NAVIGATOR_MODES.MANAGEMENT ?
            "Gestión de vacaciones"
          : "Mis vacaciones"
        }
        buttonProps={
          (
            !user.isAdminWithoutReport() &&
            mode === VACATION_PERIOD_NAVIGATOR_MODES.PERIOD
          ) ?
            !isMobile ?
              buttonHeaderProps
            : null
          : null
        }
        extraContent={
          <>
            {user.isAdmin() && (
              <ButtonWithCounter
                onClick={showHolidaysModal}
                icon={<CalendarAddIcon />}
                count={holidaysAmount}
              >
                {isMobile ? "" : "Días feriados"}
              </ButtonWithCounter>
            )}
            {!user.isAdminWithoutReport() &&
              mode === VACATION_PERIOD_NAVIGATOR_MODES.PERIOD &&
              isMobile && (
                <Button
                  onClick={(e) =>
                    setCreateModalVisible(MY_VACATION_STATES.CREATE)
                  }
                  className="border-round-3xl p-button-primary	bg-primary-highlight h-fit w-fit p-2 h-3rem w-3rem flex justify-content-center align-items-center"
                  disabled={disabled}
                >
                  <span className="pi pi-plus" />
                </Button>
              )}
          </>
        }
        subtitle={subtitleTemplate()}
      />
    </>
  )
}

export default VacationsHeader
